import React, { Component } from 'react';
import { connect } from 'react-redux';
import { withRouter } from 'react-router-dom';

import '../main.css';

class Details extends Component {
    constructor(props) {
        super(props);
        this.state = {
            item: {}
        }
    }
    componentWillMount() {
        var item = window.localStorage.getItem('activeMarker');
        this.setState({ item: JSON.parse(item) })
    }

    render() {
        return (
            <div className='container' style={{ marginTop: 50 }}>
                <div className="form-main">
                    <div className="form-item">
                        <span ><strong>Name:</strong></span>
                        <span style={{ paddingLeft: 10}}>{this.state.item.name}</span>
                    </div>
                    <div className="form-item">
                        <span ><strong>Date:</strong></span>
                        <span style={{ paddingLeft: 10}}>{this.state.item.date}</span>
                    </div>
                    <div className="form-item">
                        <span ><strong>City:</strong></span>
                        <span style={{ paddingLeft: 10}}>{this.state.item.address}</span>
                    </div>
                    <span className="form-item"><strong>Description:</strong></span>
                    <span className="form-item">{this.state.item.description}</span>
                    <div className="img-section">
                        <img src={this.state.item.imgUrl} alt="" />
                    </div>
                </div>
            </div>
        )
    }
}

const mapStateToProps = (state, props) => {
    return {
        activeMarker: state.activeMarkerReducer
    }
};

var DetailsPage = withRouter(connect(mapStateToProps)(Details));

export default DetailsPage;


// WEBPACK FOOTER //
// ./src/components/Details.js